import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useState, useEffect } from "react";

import { CountryBrandApplicationApiRepository } from "./infrastructure/CountryBrandApplicationApiRepository";
import { Home } from "./sections/home/Home";
import { Layout } from "./sections/layout/Layout";
import { CountryBrandApplicationContextProvider } from "./sections/multi_step_form/contexts/CountryBrandApplicationContextProvider";
import { MultiStepForm } from "./sections/multi_step_form/MultiStepForm";
import { Admin } from "./sections/user/Admin";
import { UserContext } from "./context/UserContext";

const repository = new CountryBrandApplicationApiRepository();
const basename = location.href.includes("/marca-pais/hacete-socio/")
	? "/es/marca-pais/hacete-socio/formulario"
	: "/en/country-brand/become-a-partner/form";

const router = createBrowserRouter(
	[
		{
			path: "/",
			element: <Layout />,
			children: [
				{
					path: "/",
					element: <Home />,
				},
				{
					path: "/admin",
					element: <Admin />,
				},
				{
					path: "/:uuid",
					element: (
						<CountryBrandApplicationContextProvider repository={repository}>
							<MultiStepForm />
						</CountryBrandApplicationContextProvider>
					),
				},
			],
		},
	],
	{
		basename,
	}
);

export function Router() {
	const [user, setUser] = useState(null);
	useEffect(() => {
		setUser(localStorage.getItem("userToken"));
	}, []);
	return (
		<UserContext.Provider value={{ user, setUser }}>
			<RouterProvider router={router} />
		</UserContext.Provider>
	);
}
